module.exports = __webpack_public_path__ + "static/media/feature-visualization.8148cd08.svg";